import React, { Component } from 'react';

export default class TransactionItem extends Component {
    render() {
        let displayPrice =  Math.round(this.props.transaction.price *100)/100
        return (
            <div>
                <div className="card" style ={{background:"aqua"}}>
                    <div className="card-body">
                        <h5 className="card-title text-uppercase">BUY ({this.props.transaction.ticker})</h5>
                        <p className="card-text">{this.props.transaction.quantity} shares @ ${displayPrice}</p>
                    </div>
                </div>
            </div>
        )
    }
}
